import { Table, Typography } from '#ui-kit';
import { TableCellAlign, TypographySize, TypographyTag } from '#ui-kit.types';
import { RegionsTableProps } from './types';

const RegionsTable: React.FC<RegionsTableProps> = ({
  data,
  loading,
  page,
  size,
  total,
  isLast,
  setPage,
  setSize,
}) => (
  <Table
    {...{
      loading,
      currentPage: page,
      pageSize: size,
      totalRows: total,
      onPageChange: (pageNumber: number, pageSize: number) => {
        setPage(pageNumber);
        setSize(pageSize);
      },
      isLast,
      header: {
        cells: {
          0: {
            width: 232,
            align: TableCellAlign.Left,
            children: (
              <Typography size={TypographySize.m} tag={TypographyTag.span}>
                ID
              </Typography>
            ),
          },
          1: {
            width: 232,
            align: TableCellAlign.Left,
            children: (
              <Typography size={TypographySize.m} tag={TypographyTag.span}>
                Наименование
              </Typography>
            ),
          },
        },
      },
      rows: data.map((item) => ({
        id: item.id,
        to: `/regions/${item.id}`,
        cells: {
          0: {
            width: 232,
            align: TableCellAlign.Left,
            onClick: () => {},
            children: (
              <Typography size={TypographySize.s} tag={TypographyTag.span}>
                {item.id}
              </Typography>
            ),
          },
          1: {
            width: 232,
            align: TableCellAlign.Left,
            onClick: () => {},
            children: (
              <Typography size={TypographySize.s} tag={TypographyTag.span}>
                {item.name}
              </Typography>
            ),
          },
        },
      })),
    }}
  />
);

export default RegionsTable;
